import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { BlobFileApiModel, ResourceApiModel, ResourceBaseApiModel, LongApiModel } from '@app/api/api-models';
import { UploadFileService } from '@app/shared/services/upload-file.service';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class ResourcesService {
  public apiUrl = 'resources';
  public uploadedFileObserver = new Subject();

  constructor(private readonly http: HttpClientService, private uploadFileService: UploadFileService) {}

  public getStorage(): Observable<LongApiModel> {
    return this.http.get<LongApiModel>(`${this.apiUrl}/get-storage-used`);
  }

  public getList(parentId = null, onlyFolders = false, programId = null): Observable<ResourceBaseApiModel[]> {
    return this.http.get<ResourceBaseApiModel[]>(`${this.apiUrl}/get-list`, {
      params: {
        programId: programId ? programId : '',
        parentId: parentId ? parentId : '',
        onlyFolders: onlyFolders.toString()
      }
    });
  }

  public upload(file: File, parentId = null): Observable<ResourceApiModel> {
    const payload = new FormData();
    this.uploadFileService.append(payload, file);

    return this.http.post<ResourceApiModel>(`${this.apiUrl}/upload`, payload, {
      params: {
        parentId: parentId ? parentId : ''
      }
    });
  }

  public download(id: string): Observable<BlobFileApiModel> {
    return this.http
      .get<BlobFileApiModel>(`${this.apiUrl}/download/${id}`)
      .pipe(map((x) => new BlobFileApiModel().deserialize(x)));
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`);
  }
}
